"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.2224092,19.7775908 L12.8276367,20.970589 L18.7732028,12.970589 C19.0100663,12.6518796 19.0337526,12.2273571 18.8442618,11.887485 L18.7732028,11.7775908 L12.8276367,3.77759079 L11.2224092,4.97058903 L16.7247152,12.3742444 L11.2224092,19.7775908 Z M4.22240921,19.7775908 L5.82763667,20.970589 L11.7732028,12.970589 C12.0100663,12.6518796 12.0337526,12.2273571 11.8442618,11.887485 L11.7732028,11.7775908 L5.82763667,3.77759079 L4.22240921,4.97058903 L9.72471523,12.3742444 L4.22240921,19.7775908 Z"
  });
}.bind(void 0));

exports.default = _default;